enum EIconPanels {
  ProtienLayer = 'Protien',
  ScreenLayer = 'Screen',
  ImageNow = 'imageNow',
  GridLayer = 'GridLayer',
  CustomLayer = 'CustomLayer',
  SeedingLayer = 'Seeding',
  RandomLayer = 'RandomLayer',
  FragmentLayer = 'Fragment Screen',
}

export enum EReportTypes {
  InstantDropReport = 'InstantDropReport',
  ExperimentReport = 'ExperimentReport',
  DesignReport = 'DesignReport',
  IngredientReport = 'IngredientReport',
  ImageReport = 'ImageReport',
  SingleDropReport = 'SingleDropReport',
  WellReport = 'WellReport',
  ScoreReport = 'ScoreReport',
  SynchrotronTripReport = 'SynchrotronTripReport',
  ScreenStockReport = 'ScreenStockReport'
}

export default EIconPanels;
